"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSONFeature = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const GeoJSON_1 = __importDefault(require("ol/format/GeoJSON"));
const react_1 = require("react");
const useMemoized_1 = require("../../hooks/useMemoized");
const OLFeature_1 = require("../../openlayers/OLFeature");
const useOLMap_1 = require("../../openlayers/useOLMap");
const bboxOrNull_1 = require("../../utils/bboxOrNull");
const fixPythagorasFeature_1 = require("../../utils/fixPythagorasFeature");
const polygonToOLPolygon_1 = require("../../utils/polygonToOLPolygon");
const parser = new GeoJSON_1.default({
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
});
const GeoJSONFeature = function GeoJSONFeature(_a) {
    var _b, _c;
    var { feature: geoJsonFeature, onEdit, renderMode, autoCenter } = _a, props = __rest(_a, ["feature", "onEdit", "renderMode", "autoCenter"]);
    const memoizedGeoJsonFeature = useMemoized_1.useMemoized(geoJsonFeature);
    const fixedMemoizedGeoJsonFeature = react_1.useMemo(() => {
        return fixPythagorasFeature_1.fixPythagorasFeature(memoizedGeoJsonFeature);
    }, [memoizedGeoJsonFeature]);
    const feature = react_1.useMemo(() => {
        var _a;
        const id = `${lodash_1.uniqueId()}${(_a = fixedMemoizedGeoJsonFeature.id) !== null && _a !== void 0 ? _a : ''}`;
        const feature = parser.readFeature(fixedMemoizedGeoJsonFeature);
        feature.setId(id);
        return feature;
    }, [fixedMemoizedGeoJsonFeature]);
    const type = (_c = (_b = fixedMemoizedGeoJsonFeature.properties) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : null;
    const baseStyles = react_1.useMemo(() => {
        if (!type) {
            return {};
        }
        return {
            backgroundColor: `floorplans.${type}.background`,
            borderColor: `floorplans.${type}.border`,
            borderWidth: type.startsWith('fixture.door') ? 3 : type.startsWith('area.group') ? 0 : 1,
        };
    }, [type]);
    const onEditOLFeature = react_1.useCallback(({ geometry }) => {
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(Object.assign(Object.assign({}, geoJsonFeature), { geometry: parser.writeGeometryObject(geometry) }));
    }, [geoJsonFeature, onEdit]);
    const map = useOLMap_1.useOLMap();
    react_1.useEffect(() => {
        var _a;
        if (autoCenter) {
            const polygonOrExtent = (_a = polygonToOLPolygon_1.polygonToOLPolygon(memoizedGeoJsonFeature.geometry)) !== null && _a !== void 0 ? _a : bboxOrNull_1.bboxOrNull({ type: 'FeatureCollection', features: [memoizedGeoJsonFeature] });
            if (!polygonOrExtent) {
                return;
            }
            setTimeout(() => {
                try {
                    map.getView().fit(polygonOrExtent, {
                        size: map.getSize(),
                        padding: [20, 20, 20, 20],
                    });
                }
                catch (e) {
                    console.error(e);
                }
            }, 100);
        }
    }, [autoCenter, map, memoizedGeoJsonFeature]);
    return (jsx_runtime_1.jsx(OLFeature_1.OLFeature, Object.assign({ feature: feature, renderMode: renderMode }, lodash_1.merge({}, baseStyles, props), { onEdit: onEditOLFeature }), void 0));
};
exports.GeoJSONFeature = GeoJSONFeature;
//# sourceMappingURL=index.js.map